import React from 'react'
import { formatBs } from './utils'

const podiumClass = (idx) => {
    if (idx === 0) return 'bg-yellow-400 text-gray-900'
    if (idx === 1) return 'bg-gray-300 text-gray-800'
    if (idx === 2) return 'bg-amber-700 text-white'
    return 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
}

export const RankingList = ({ items = [], emptyText = 'Sin datos' }) => {
    if (!items?.length) {
        return (
            <div className='text-sm text-gray-500 dark:text-gray-400 italic px-2 py-4 text-center'>
                {emptyText}
            </div>
        )
    }

    return (
        <ol className='flex flex-col gap-1'>
            {items.map((item, idx) => (
                <li
                    key={item.user_id ?? item.encargado_id ?? idx}
                    className='flex items-center gap-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md px-3 py-2'
                >
                    <span className={`flex items-center justify-center w-7 h-7 min-w-7 rounded-full font-bold text-sm ${podiumClass(idx)}`}>
                        {idx + 1}
                    </span>
                    <div className='flex-1'>
                        <div className='font-semibold text-gray-800 dark:text-gray-200 text-sm'>
                            {item.nombre || `Usuario #${item.user_id ?? item.encargado_id}`}
                        </div>
                        {item.codigo && (
                            <div className='text-xs text-gray-500 dark:text-gray-400'>Código: {item.codigo}</div>
                        )}
                    </div>
                    <div className='font-bold text-teal-600 dark:text-yellow-500 text-sm text-right whitespace-nowrap'>
                        Bs {formatBs(item.total)}
                    </div>
                </li>
            ))}
        </ol>
    )
}
